var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham-dark",staticStyle:{"width":"100%","height":"300px"},attrs:{"gridOptions":_vm.gridOptions,"rowData":_vm.records}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }